import { Characteristic } from "../../interface/tasks/taskOperationsResponse";

export class TaskOperationDto {
    constructor(private operationType: string, private executionDate: Date, private creationDate: Date, 
      private statusOperation: string, private operationActionType: string, private characteristic: Characteristic[], 
      private comment: string, private user: string, private description: string, private errorCode: string, 
      private activity: string) {
      }
}
